module.exports = __webpack_public_path__ + "static/media/stripe.956c6f1f.png";